'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var checkStringOverMaxLength = function (input, max) {
    if (!max || max <= 0) {
        return { error: false };
    }
    if (typeof input !== 'string') {
        return { error: true, messageFragment: 'string is required' }; // shouldn't be hit
    }
    if (input.length > max) {
        return { error: true, messageFragment: "must be shorter than " + max };
    }
    return { error: false };
};
var checkStringOverMaxLengthGenerator = function (max) { return function (input) {
    return checkStringOverMaxLength(input, max);
}; };
var isPresent = function (input, message) {
    if (!input || input.length === 0) {
        return { error: true, messageFragment: message !== null && message !== void 0 ? message : 'Cannot be left blank' };
    }
    return { error: false };
};
var isPresentGenerator = function (message) { return function (input) {
    return isPresent(input, message);
}; };
var isSelected = function (input, message) {
    if (!input || input.length === 0 || input === 'xxxx') {
        return { error: true, messageFragment: message !== null && message !== void 0 ? message : 'Cannot be left blank' };
    }
    return { error: false };
};
var isSelectedGenerator = function (message) { return function (input) {
    return isSelected(input, message);
}; };
var getErrorValue = function (target, errorsProp) {
    return Object.values(errorsProp).find(function (v) {
        var _a;
        var errorAttribute = (_a = v === null || v === void 0 ? void 0 : v.messageFragment) === null || _a === void 0 ? void 0 : _a.split(':')[0];
        return errorAttribute === target;
    });
};
var isError = function (target, errorsProp) {
    return !!getErrorValue(target, errorsProp);
};
var getError = function (target, errorsProp) {
    var _a;
    var val = getErrorValue(target, errorsProp);
    return (_a = val === null || val === void 0 ? void 0 : val.messageFragment) === null || _a === void 0 ? void 0 : _a.split(':')[1];
};

exports.checkStringOverMaxLength = checkStringOverMaxLength;
exports.checkStringOverMaxLengthGenerator = checkStringOverMaxLengthGenerator;
exports.getError = getError;
exports.isError = isError;
exports.isPresent = isPresent;
exports.isPresentGenerator = isPresentGenerator;
exports.isSelectedGenerator = isSelectedGenerator;
